import HeatDiagram from "./heat-diagram.vue";

export default HeatDiagram;



// WEBPACK FOOTER //
// ./src/components/_heat-diagram/index.js